import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-27dac389"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "course"
};
const _hoisted_3 = {
  class: "course-img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "bottom"
};
const _hoisted_6 = {
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_7 = {
  class: "course-teacher text-overflow"
};
const _hoisted_8 = {
  class: "teacher-photo"
};
const _hoisted_9 = {
  class: "photo-item"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "teacher-info"
};
const _hoisted_12 = {
  class: "name text-overflow"
};
const _hoisted_13 = {
  class: "organ_name text-overflow"
};
const _hoisted_14 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    href: $props.authType == 2 && !$props.userInfo ? _ctx.$zhsLoginUrl : $props.courseData.course_url,
    target: "_blank",
    class: "course-card"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($props.courseData.course_name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: require('../../../assets/images/user_avatar.jpg'),
    alt: ""
  }, null, 8, _hoisted_10)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($props.courseData.lecturer), 1)])]), _createElementVNode("p", _hoisted_13, [_createTextVNode(_toDisplayString($props.courseData.organ_name) + " ", 1), $props.courseData.organ_name && $props.courseData.post ? (_openBlock(), _createElementBlock("span", _hoisted_14, "-")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($props.courseData.post), 1)])])])], 8, _hoisted_1);
}